
import React from "react";
import BookPreview from "@/components/BookPreview";

const BookPreviewSection: React.FC = () => {
  return (
    <section className="mb-20">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">Includes Director's Handbook</h2>
      <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
        <BookPreview showFullDetails={true} />
      </div>
      <div className="mt-6 text-center">
        <p className="text-lg text-gray-700 italic max-w-2xl mx-auto">
          The handbook includes all 12 chapters with frameworks, templates, and checklists
          to accelerate your AI governance journey.
        </p>
      </div>
    </section>
  );
};

export default BookPreviewSection;
